<template>
  <div class="productSort">
    <form @submit.prevent="submitForm">
      <div class="header acea-row row-center-wrapper" ref="header">
        <div class="acea-row row-between-wrapper input">
          <span class="iconfont icon-sousuo"></span>
          <input type="text" placeholder="搜索商品信息" v-model="search" />
        </div>
      </div>
    </form>
    <div class="aside">
      <div class="item acea-row row-center-wrapper" :class="index === navActive ? 'on' : ''"
        v-for="(item, index) in classify" :key="index" @click="asideTap(index, item.id)">
        <span>{{ item.cate_name }}</span>
      </div>
    </div>
    <div class="conter" @scroll.native="onScroll">
      <div class="list acea-row">
        <div class="item" v-for="(item, index) in category" :key="index">
          <div class="picture" @click="jump(item)">
            <img :src="item.image" />
          </div>
          <div class="name line1" style="">
            <p class="tit" @click="jump(item)">{{ item.store_name }}</p>
            <div class="price">
              <p>
                <span class="money">￥<span>{{ item.price }}</span></span>
              </p>
              <p class="shopCar" @click="addCar(item)" v-if="item.stock != 0 && item.virtual != 1">
                <span class="iconfont icon-gouwuche"></span>
              </p>
              <p class="shopCarText" @click="goCart(item)" v-if="item.virtual == 1">
                {{ type == 66 ? '充值' : '购买' }}
              </p>
            </div>
            <p v-if="item.stock == 0">已售罄</p>
          </div>

        </div>
        <div v-if="category.length === 0" class="zan">
          <p>暂无数据</p>
        </div>
      </div>
      <Loading :loaded="loadend" :loading="loading"></Loading>
      <Product-window-vitual v-on:changeFun="changeFun" :attr="attr"></Product-window-vitual>
    </div>

    <div style="height: 1.2rem"></div>
  </div>
</template>
<script>
import ProductWindowVitual from "@components/ProductWindowVitual";
import { oAuth, toAuth } from "@libs/wechat";
import { auth } from "@libs/wechat";
import debounce from "lodash.debounce";
import { getCategory, postCartAdd, postCartVerify } from "@api/store";
import { trim } from "../../utils";
import { classifyApi, getShopApi } from "@api/login";
import Loading from "@components/Loading";
let url = location.href;
// console.log(url);
let type = url.slice(-2);
if (type[0] === "/") {
  type.slice(0, 1);
}
export default {
  name: "GoodsClass",
  components: {
    Loading,
    ProductWindowVitual,
  },
  props: {},
  data: function () {
    return {
      attr: {
        cartAttr: false,
        cartData: {},
        type: ''
      },
      category: [],
      navActive: 0,
      search: "",
      lock: false,
      classify: [],
      classifyId: null,
      page: 1, //页码
      limit: 20, //数量
      loaded: false,
      loading: false,
      type: this.$route.path.slice(-2),
      isCut: false,
      search: ''
    };
  },
  watch: {
    "$route.params.pid": function (n) {
      // console.log(n, "=======111");
      // if (n) {
      //   this.activeCateId(n);
      // }
    },
    "$route": function (n, o) {
      console.log(this.navActive)
      if (o.path.indexOf('detail') != -1) {
        setTimeout(() => {
          // this.navActive = localStorage.getItem('navActive');

        })
      }
    },
  },
  mounted: function () {
    document.addEventListener("scroll", this.onScroll, false);
    this.getClassify();
    this.getShop();
    localStorage.setItem("type", type);
    this.$forceUpdate();
  },
  methods: {
    changeFun() { },
    goCart: function (item) {
      if (item.is_sale) {
        this.attr.cartAttr = true;
        this.attr.cartData = item;
        this.attr.type = this.type;
      } else {
        this.$dialog.toast({ mes: "未到购买时间!" });
      }

    },
    refresh() {
      this.$forceUpdate();
    },
    // activeCateId(n) {
    //   console.log('这是什么东西')
    //   let index = 0;
    //   n = parseInt(n);
    //   if (!n) return;
    //   this.category.forEach((cate, i) => {
    //     if (cate.id === n) index = i;
    //   });

    //   if (index !== this.navActive) {
    //     this.asideTap(index, this.classifyId);
    //   }
    // },
    // loadCategoryData() {
    //   getCategory().then((res) => {
    //     this.category = res.data;
    //     this.$nextTick(() => {
    //       if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
    //       else this.onScroll();
    //     });
    //   });
    // },
    submitForm: function () {
      var val = trim(this.search);
      this.search = val
      // 老逻辑跳转新页面
      // if (val) {
      //   this.$router.push({
      //     path: "/goods_list",
      //     query: { s: val, type: this.type },
      //   });
      //   setTimeout(() => (this.search = ""), 500);
      // }
      this.page = 1;
      getShopApi({
        page: this.page,
        limit: this.limit,
        sid: this.classifyId,
        store_name: this.search ? this.search : ''
      }).then((res) => {
        this.category = res.data;
        this.loading = false;
        this.loaded = res.data.length < this.limit; //判断所有数据是否加载完成；
        this.page++;
        document.body.scrollIntoView()
      });
    },
    asideTap(index, id) {
      this.navActive = index;
      this.classifyId = id;
      this.page = 1;
      let that = this;
      getShopApi({
        page: this.page,
        limit: this.limit,
        sid: this.classifyId,
        store_name: this.search ? this.search : ''
      }).then((res) => {
        this.category = res.data;
        this.loading = false;
        this.loaded = res.data.length < this.limit; //判断所有数据是否加载完成；
        this.page++;
        document.body.scrollIntoView()
      });
    },
    onScroll: debounce(function () {
      if (this.loading || this.loaded) return;
      getShopApi({
        page: this.page,
        limit: this.limit,
        sid: this.classifyId,
        store_name: this.search ? this.search : ''
      }).then((res) => {
        if (this.page == 1) {
          this.category = res.data;
        } else {
          this.category = this.category.concat(res.data);
        }
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    }, 500),
    // 获取分类信息
    getClassify() {
      // 获取当前路由信息
      let type = this.type;
      if (this.type[0] === "/") {
        type.slice(1);
      }
      this.type = type;
      classifyApi(type).then((res) => {
        this.classify = res.data;
        this.classifyId = res.data[0].id;
      });
    },
    // 获取商品数据
    getShop() {
      let type = this.type;
      let id = null;
      if (this.type[0] === "/") {
        type.slice(1);
      }
      let that = this;
      classifyApi(type).then((res) => {
        this.classify = res.data;
        this.classifyId = res.data[0].id;
        if (that.loading) return; //阻止下次请求（false可以进行请求）；
        if (that.loaded) return; //阻止结束当前请求（false可以进行请求）；
        that.loading = true;
        getShopApi({
          page: 1,
          limit: this.limit,
          sid: this.classifyId,
          store_name: this.search ? this.search : ''
        }).then((res) => {
          this.category = res.data;
          that.loading = false;
          that.loaded = res.data.length < that.limit; //判断所有数据是否加载完成；
          this.page = this.page + 1;
        });
      });
    },
    // 跳转详情页
    jump(item) {
      if (item.is_sale == 0) {
        this.$dialog.toast({ mes: "未到购买时间!" });
        return
      }
      localStorage.setItem('navActive', this.navActive)
      if (item.virtual == 1) {
        this.goCart(item)
        return
      }
      this.$router.push({
        path: "/detail/" + item.id,
        query: { type: this.type, is_sale: item.is_sale },
      });
    },
    // 加入购物车
    addCar(item) {
      if (item.is_sale == 0) {
        this.$dialog.toast({ mes: "未到购买时间!" });
        return
      }
      let that = this;
      postCartAdd({
        productId: item.id,
        cartNum: 1,
        new: 0,
        uniqueId: item.unique,
      })
        .then((res) => {
          that.$dialog.success("加入购物车成功");
        })
        .catch((err) => {
          this.$dialog.error(err.msg);
          // oAuth().then((res) => {
          //   // 待操作 上传到后端后 写逻辑
          // });
        });
    },
  },
  beforeDestroy: function () {
    document.removeEventListener("scroll", this.onScroll, false);
  },
};
</script>
<style lang="scss" scoped>
.zan {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;

  p {
    margin-top: 50%;
    color: #ccc;
  }
}

.productSort .conter .list .item {
  border-bottom: 1px solid #ccc;
}

.productSort .conter .list .item .picture {
  width: 120rpx;
  height: 120rpx;

}

.productSort .conter .list .item {
  width: calc(100vw - 105px);
  display: flex;
  position: relative;
  padding-bottom: 2px;
}

.productSort .conter .list {
  display: flex;

}

.productSort .conter .list .item .name {
  height: auto;
  margin-left: 0.2rem;
  flex: 1;


  p {
    text-align: left;
    width: calc(100vw - 105px - 120rpx);
    margin-bottom: 5px;
  }

  .shopCar {
    right: 10px;
    text-align: right;
    z-index: 1000;
    padding-top: 5px;
  }

  .shopCarText {
    padding-top: 5px;
    text-align: right;
    z-index: 1000;
    right: 10px;

  }
}

.productSort .conter .list .item .picture img {
  // width: 120rpx;
  // height: 120rpx;
  border-radius: 0.2rem;
}

.tit {
  font-weight: 500;
  color: black;
  font-size: 14px;
  // background: red;
  overflow: auto;
  word-wrap: break-word;
  word-break: break-all;
  // text-overflow: ellipsis;
  white-space: break-spaces;
}

.price {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.money {
  color: red;

  span {
    font-size: 16px;
  }
}

.jia {
  position: absolute;
  right: 40px;
  // width: 25px;
  // height: 25px;
  // border-radius: 50%;
  background-color: #00a2ff;
  text-align: center;
  color: white;
  // line-height: 25px;
  box-sizing: border-box;
  padding: 0.1rem;
  font-size: 0.24rem;
  margin-top: 0.1rem;
}

.aside {
  height: calc(100vh - 48px);
}

.productSort .aside .item.on {
  background-color: #fff;
  font-weight: bold;
  border-left: none;
  color: black;
}
</style>
